import api from 'src/config/api';
import {
	ICreateQuestionnaireSubmissionRequest,
	IQuestionnaire,
} from 'src/features/questionnaire/domain/types';

export const questionnaireApi = {
	getQuestionnaireSubmission: async (
		questionnaireId: number,
		studyId: number,
		siteSlug: string,
	): Promise<IQuestionnaire> => {
		const params = new URLSearchParams({
			questionnaire_id: JSON.stringify(questionnaireId),
		});

		const response = await api.get(
			`/api/v1/study/${studyId}/questionnaire-submission?${params}`,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);

		return response.data;
	},

	createQuestionnaireSubmission: async (
		requestBody: ICreateQuestionnaireSubmissionRequest,
		siteSlug: string,
	): Promise<void> => {
		const response = await api.post(
			`/api/v1/questionnaire/submission`,
			requestBody,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);

		return response.data;
	},
};
